// Vinica — behaviour: header contrast, mobile drawer, reveal on scroll, cart count, toast
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Mobile drawer ──────────────────────────────────────────────
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.getElementById('MobileDrawer');
  var closers = document.querySelectorAll('[data-nav-close]');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('nav-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('nav-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  if (toggle) toggle.addEventListener('click', openDrawer);
  closers.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // ── FAQ accordion ─────────────────────────────────────────────
  document.querySelectorAll('.faq__q').forEach(function (button) {
    button.setAttribute('aria-expanded', button.closest('.faq__item').classList.contains('is-open') ? 'true' : 'false');
    button.addEventListener('click', function () {
      var item = button.closest('.faq__item');
      var open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ── Reveal on scroll (progressive enhancement) ──────────────────
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduce) {
    document.body.classList.add('js-reveal');
    var shown = new WeakSet();
    var show = function (el) { if (!shown.has(el)) { shown.add(el); el.classList.add('is-in'); } };
    var ir = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); ir.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (el) { ir.observe(el); });
    // First-paint safety
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      reveals.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) show(el);
      });
    });
    setTimeout(function () { reveals.forEach(show); }, 1200);
  }

  // ── Cart count sync from localStorage (if merchant does not update DOM) ──
  var cartEl = document.querySelector('[data-cart-count]');
  var setCart = function () {
    var n = parseInt(localStorage.getItem('vc_cart') || '0', 10);
    if (cartEl && !isNaN(n) && !cartEl.textContent) cartEl.textContent = String(n);
  };
  setCart();
  window.addEventListener('storage', setCart);

  // ── Toast ──────────────────────────────────────────────────────
  var toast = document.createElement('div');
  toast.className = 'toast';
  document.body.appendChild(toast);
  var toastTimer;
  window.vcToast = function (msg) {
    toast.textContent = msg;
    toast.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-in'); }, 2400);
  };
})();
